import { DatePipe } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { console_log, DataProvider } from 'src/providers/data/data';
import { CallapiService } from 'src/providers/rest/callapi.service';

@Component({
  selector: 'app--contract-salecompany-detail',
  templateUrl: './salecompany-contract-detail.component.html',
  styleUrls: ['./salecompany-contract-detail.component.scss'],
})
export class SaleCompanyContractDetailComponent implements OnInit {
  public uuid;
  public Corporate_Status;
  public Corporation_Form;
  public Company_Name;
  public Company_Name_Kana;
  public Post_Code;
  public Address_1;
  public Address_2;
  public Address_3;
  public TelePhone;
  public Email;
  public Last_Name;
  public Name;
  public Last_Name_Kana;
  public Name_Kana;
  public business_type;
  public BusinessType = [];
  public Business_Type_Name;  
  public New_Mail;
  public today;
  public app_date;
  isPopupVisible: boolean = false;
  isPopupVisibleReEmail: boolean = false;
  isConfirmPopupVisible: boolean = false;
  isErrorMailPopupVisible: boolean = false;
  isConfirmNewEmailPopupVisible: boolean = false;
  public isErrorPopupVisible = false;
  public errorText = '';
  popupMessage: string = '';
  public documentpdf;
  public Acquired_Company_Name;
  public App_Date;
  public Start_Date;
  public End_Date;
  public Staff_Position;
  public Staff_Post;
  public Staff_Last_Name;
  public Staff_First_Name;
  public Number_Off_Employees;
  public Contract_Uuid;
  public pages;
  public wf_salecompany_contract_detail: boolean;


  constructor(
    private router: Router,
    public data: DataProvider,
    private route: ActivatedRoute,
    public rest: CallapiService,
    private spinner: NgxSpinnerService,
    protected datepipe: DatePipe,
    public translate: TranslateService,
  ) {
    this.BusinessType = [
      {code: "01", name: "農業・林業"},
      {code: "02", name: "漁業"},
      {code: "03", name: "鉱業，採石業，砂利，採取業"},
      {code: "04", name: "建設業"},
      {code: "05", name: "製造業"},
      {code: "06", name: "電気・ガス・熱供給・水道業"},
      {code: "07", name: "情報通信業"},
      {code: "08", name: "運輸業，郵便業"},
      {code: "09", name: "卸売業，小売業"},
      {code: "10", name: "金融業，保険業"},
      {code: "11", name: "不動産業，物品賃貸業"},
      {code: "12", name: "学術研究，専門・技術サービス業"},
      {code: "13", name: "宿泊業，飲食サービス業"},
      {code: "14", name: "生活関連サービス業，娯楽業"},
      {code: "15", name: "教育，学習支援業"},
      {code: "16", name: "医療，福祉"},
      {code: "17", name: "複合サービス事業"},
      {code: "18", name: "サービス業"},
      {code: "19", name: "公務"},
      {code: "20", name: "分類不能の産業"},
    ];
  }

  ngOnInit() {
    this.data.menuPageTitle = 'wf-salecompany-contract-list';
    this.uuid = this.route.snapshot.paramMap.get('uuid');
    this.spinner.show()
    this.rest.Get_Screenauth(this.data.uuid).subscribe(
      (res) => {

        this.pages = res.data;
        for (let i = 0; i < this.pages.length; i++) {
          if (this.pages[i].pagename == 'wf-salecompany-contract-detail') {
            if (this.pages[i].auth == 'F') {
              this.wf_salecompany_contract_detail = true;
            }
            if (this.pages[i].auth == 'R') {
              this.wf_salecompany_contract_detail = false;
            }
            if(this.pages[i].auth == 'D'){
              this.router.navigate(['/']);
            }
          }
        }
        // var pages = res.data;
        // const page = pages.find(page => page.pagename === 'wf-salecompany-contract-detail');
        // var bool = page ? page.auth === "F" : false;
        // if (!bool) {
        //   this.router.navigate(['/']);
        // }
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
    this.rest.Get_SaleCompanyId(this.data.uuid, this.uuid).subscribe(
      (res) => {
        this.Corporate_Status = res.data.corporate_status;
        this.Corporation_Form = res.data.corporation_form;
        this.Company_Name = res.data.company_name;
        this.Company_Name_Kana = res.data.company_name_kana;
        this.Post_Code = res.data.postcode;
        this.Address_1 = res.data.address_1;
        this.Address_2 = res.data.address_2;
        this.Address_3 = res.data.address_3;
        this.TelePhone = res.data.tel;
        this.Email = res.data.mail_address;
        this.Last_Name = res.data.staff_last_name;
        this.Name = res.data.staff_first_name;
        this.Last_Name_Kana = res.data.staff_last_name_kana;
        this.Name_Kana = res.data.staff_first_name_kana;
        this.Business_Type_Name = this.getBusinessTypeName(res.data.business_type.length == 1 ? '0' + res.data.business_type : res.data.business_type);
        this.Acquired_Company_Name = res.data.acquired_name;
        this.App_Date = res.data.app_date;
        this.Start_Date = res.data.start_date;
        this.End_Date = res.data.end_date;
        this.Staff_Position = res.data.staff_position;
        this.Staff_Post = res.data.staff_post;
        this.Number_Off_Employees = res.data.users;
        this.Contract_Uuid = res.data.contract_uuid;
        this.spinner.hide();
      },
      (err) => {
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/wf-contract-err', {code: err.error.error.code}]);
      }
    );
    this.widthChanger('main-header', 752);
  }
  getBusinessTypeName(code) {
    const business = this.BusinessType.find(b => b.code === code);
    return business ? business.name : '';
  }
  widthChanger(className, width) {
    const headers = document.getElementsByClassName(className);
        for (let i = 0; i < headers.length; i++) {
          const header = headers[i] as HTMLElement;
          
          header.style.minWidth = width.toString() + 'px';
      }
  }
  back() {
    this.router.navigate(['/wf-salecompany-contract-list']);
  }
  edit() {
    this.router.navigate(['/wf-salecompany-contract-edit', { uuid: this.uuid }]);
  }

  dataValidation() {
    let err = false;
    let errTxt = '';
    let Number = /^-?\d*$/;
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    if (this.New_Mail == null || this.New_Mail == '' || this.New_Mail == undefined) {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_MAIL')
        .subscribe((res) => (errTxt = res));
    }else if (this.New_Mail != "" && (this.New_Mail.length <= 5 || !EMAIL_REGEXP.test(this.New_Mail))) {
      err = true;
      this.translate
        .get('COMPANY_REGISTER_VALIDATION.ERROR_MAIL')
        .subscribe((res) => (errTxt = res));
    }
    if (err) {
      document.getElementById('error').innerHTML = errTxt;
      document.getElementById('error').style.display = 'block';
      return false;
    }
    
    return true;
  }

  change() {
    this.spinner.show();
    if (!this.dataValidation()) {
      this.spinner.hide();
      return true;
    } else {
      this.today = new Date();
      this.app_date = this.datepipe.transform(this.today, 'yyyyMMddHHmmss');
      const body = {
        data:{
            user_uuid: this.data.uuid,
            uuid:  this.uuid,
            new_email: this.New_Mail,
            time: this.app_date
        }
      };
      console_log(body)
      this.rest.Send_MailChangeMail(
        this.data.uuid,
        // this.uuid,
        this.Contract_Uuid,
        this.New_Mail,
        this.app_date
      ).subscribe(
        (res) => {
            console_log(res);
            this.isPopupVisible = false; 
            this.spinner.hide();
            this.isConfirmNewEmailPopupVisible = true;
            this.errorText = `メールアドレス変更の申請を承りました。変更確定のための確認メールが担当者に送信されました。`;
            // this.router.navigate(['/contract-mail-sended']);
          },(err) => {
            this.spinner.hide();
            this.isPopupVisible = false; 
            this.isErrorPopupVisible = true;
            const code = err.error?.error?.code ;
            this.translate.get('ERROR.' + code).subscribe(res => {
              this.errorText = `${res} <br> (${code})`;
            });
          }
      );
    }
  }
  openPopup(): void {
    this.popupMessage = '';
    this.isPopupVisible = true;
  }
  closePopup(): void {
    this.isPopupVisible = false;
  }
  openPopupReEmail(): void {
    this.isPopupVisibleReEmail = true;
  }
  closePopupReEmail(): void {
    this.isPopupVisibleReEmail = false;
    this.popupMessage = '';
  }

  
  pdf_download(){
    this.rest
      .Download_Regcertificates(this.data.uuid, this.uuid)
      .subscribe((res) => {
        if (res.code == 'S000001') {
          this.documentpdf = res.data.s3url;
          window.open(this.documentpdf, '_blank', '');
        }
      },
      (err) => {
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
      }
      );
  }
  send(){
    this.spinner.show()
    this.rest.Send_ReApplicationsSalesId(this.data.uuid, this.uuid,'F00013',this.Corporate_Status,this.Company_Name,this.Email,this.Name, this.Last_Name).subscribe((res) => {
      if (res.code == 'S000001') {
        this.isPopupVisibleReEmail = false;
        this.popupMessage = '';
        this.isPopupVisible = false; 
        this.isConfirmPopupVisible = true;
        this.errorText = `審査結果の再送信を完了しました`;
        this.spinner.hide();
      }
    },
    (err) => {
      console_log(err);
      this.spinner.hide();
      // this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
      this.isPopupVisible = false; 
      this.isErrorMailPopupVisible = true;
      const code = err.error?.error?.code ;
      this.translate.get('ERROR.' + code).subscribe(res => {
        this.errorText = `${res} <br> (${code})`;
      });
    }
    );
  }
}
